import { useUserStore } from '~/stores/auth';
import { DEBUG, GLOBAL_MESSAGE_EVENT, type PayloadDataType } from './index';
import { useChannelsStore } from '~/stores/channels';
import type { Emitter } from '~/plugins/emitter';

type DeleteMember = {
  eventType: 'DEACTIVATE_TEAM_MEMBER';
  email: string;
  channelId: number;
  teamId: number;
  userId: number;
  userName: string;
  teamName: string;
};

const contextUser = (userId: number) => {
  const piniaUser = useUserStore();
  const ctxId = piniaUser.user as unknown as {
    summary: { basicUserInfo: { userId: number } };
  };
  return ctxId.summary.basicUserInfo.userId === userId;
};

const processedDeletes = new Set<string>();

export function handleDeleteMember(
  ...[_channel, data]: PayloadDataType<DeleteMember>
) {
  if (DEBUG) console.log('handlePusherMessages', data);

  const deleteKey = `${data.channelId}-${data.email}-${data.teamId}`;
  if (processedDeletes.has(deleteKey)) {
    return;
  }
  processedDeletes.add(deleteKey);
  setTimeout(() => processedDeletes.delete(deleteKey), 5000);

  const piniaChannels = useChannelsStore();
  piniaChannels.refetchAffectedMemberCaches(data.channelId, data.teamId);
  piniaChannels.refetchAffectedMemberDetail(
    data.channelId,
    `${data.channelId}-${data.userId}`
  );

  if (contextUser(data.userId)) {
    const emitter = useNuxtApp().$emitter as Emitter;
    emitter.$emit(GLOBAL_MESSAGE_EVENT, {
      message: `${data.userName} has been removed from ${data.teamName}.`,
      status: 200,
    });
  }
}
